import React, { useEffect, useRef, useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import { TextField } from "@material-ui/core";

const CustomSizeDialog = ({ open, onClose, onContinue }) => {
  const [width, setWidth] = useState('');
  const [height, setHeight] = useState('');
  const [errors, setErrors] = useState({ width: '', height: '' });

  const widthNum = parseFloat(width);
  const heightNum = parseFloat(height);

  const widthInInches = width && width > 0 && !isNaN(widthNum) ? (widthNum / 25.4).toFixed(2) : ''
  const heightInInches = height && height > 0 && !isNaN(heightNum) ? (heightNum / 25.4).toFixed(2) : ''

  const handleSubmit = () => {
    // Reset errors
    setErrors({ width: '', height: '' });

    let hasErrors = false;
    const newErrors = { width: '', height: '' };

    // Validate width
    if (!width || isNaN(widthNum)) {
      newErrors.width = 'Please enter a valid number';
      hasErrors = true;
    } else if (widthNum < 50) {
      newErrors.width = 'Width must be at least 50 mm';
      hasErrors = true;
    }

    // Validate height
    if (!height || isNaN(heightNum)) {
      newErrors.height = 'Please enter a valid number';
      hasErrors = true;
    } else if (heightNum < 50) {
      newErrors.height = 'Height must be at least 50 mm';
      hasErrors = true;
    }

    if (hasErrors) {
      setErrors(newErrors);
      return;
    }

    // Convert to the required format
    const sizeObject = {
      displayWidth: `${widthInInches}"`,
      displayHeight: `${heightInInches}"`,
      displaySizeInMm: `${widthNum}mm × ${heightNum}mm`,
      widthInMm: widthNum,
      heightInMm: heightNum,
      width: widthNum,
      height: heightNum,
      iconWidth: Math.round(widthInInches * 10), // Proportional icon size
      iconHeight: Math.round(heightInInches * 10),
      isCustomSize: true
    };

    onContinue(sizeObject);
    onClose();
  };

  useEffect(() => {
    if (open) {
      setWidth('');
      setHeight('');
      setErrors({ width: '', height: '' });
    }
  }, [open])

  const inputRef = useRef(null);

  const handleEntered = () => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };

  return (
    <Dialog
      open={open}
      TransitionProps={{
        onEntered: handleEntered,
      }}
      onClose={onClose}
      disableEnforceFocus
    >
      <DialogContent>
        <h3 className="dialog-title">Enter badge dimensions in mm</h3>
        <div className="print-dialog-content">
          <TextField
            inputRef={inputRef}
            autoFocus
            margin="dense"
            label="Width (mm)"
            type="number"
            fullWidth
            value={width}
            onChange={(e) => {
              setErrors({ ...errors, width: '' });
              setWidth(e.target.value)
            }}
            error={!!errors.width}
            helperText={errors.width || (widthInInches ? `${widthInInches} inches` : '')}
            inputProps={{ step: "1" }}
          />
          <TextField
            margin="dense"
            label="Height (mm)"
            type="number"
            fullWidth
            value={height}
            onChange={(e) => {
              setErrors({ ...errors, height: '' });
              setHeight(e.target.value)
            }}
            error={!!errors.height}
            helperText={errors.height || (heightInInches ? `${heightInInches} inches` : '')}
            inputProps={{ step: "1" }}
          />
        </div>
      </DialogContent>
      <DialogActions>
        <button className="button" onClick={onClose}>
          Back
        </button>
        <button
          className="primary"
          onClick={handleSubmit}
        >
          Continue
        </button>
      </DialogActions>
    </Dialog>
  );
};

export default CustomSizeDialog;
